<ng-container *ngIf="eventsFound | async">
    <div class="container">
        <section>
            <!-- <div class="ngx-spinner123" style="position: relative;">
                <ngx-spinner color="grey" size="small" [fullScreen]="false" bdColor="rgba(0,0,0,0)"></ngx-spinner>
            </div> -->
            <div class="page-header page-header--center">
                <h1 *ngIf="eventsFound">Current activity</h1>
                <div *ngIf="eventsFound">
                    <p *ngIf="repairAppointments && repairAppointments.length > config.defaultMinEvents">
                        Showing {{ config.limitVisibleEvents === true ? config.defaultMinEvents :
                        repairAppointments.length }} of {{ repairAppointments.length}}
                    </p>
                    <div class="activities">
                        <div class="activities__wrapper__home">
                            <table class="activities__table table table-striped">
                                <thead class="sr-only">
                                    <tr>
                                        <th>Category</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let appointment of repairAppointments; let i = index;">
                                        <tr class="activity" *ngIf="repairAppointments">
                                            <ng-container *ngIf="i < config.eventsToShow">
                                                <td class="activity__category">
                                                    <a href="/repairs"><i
                                                            class="table__icon table__icon--small fa fa-wrench"
                                                            aria-hidden="true"></i>
                                                        <p
                                                            *ngFor="let repairDescription of appointment.repairDescription">
                                                            {{appointment.repairDescription}}
                                                        </p>
                                                    </a>
                                                </td>
                                                <td class="activity__description">
                                                    <strong>{{appointment.appointmentDescription}} </strong> -
                                                    {{appointment.contractorName}} will be attending
                                                </td>
                                            </ng-container>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                        <button class="activities__btn activities__btn--show btn btn-block btn-primary"
                            *ngIf="repairAppointments && repairAppointments.length > config.defaultMinEvents"
                            (click)="showMoreActivities()">{{
                            config.limitVisibleEvents === true ? 'Show more activities' : 'Show less activities'
                            }}</button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</ng-container>
